import {
  Component,
  Input,
  OnInit,
  SecurityContext
} from '@angular/core';
import { DomSanitizer }     from '@angular/platform-browser';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';
import { NgForm }           from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { CustomerModel }             from '../customers/models/customer';
import { MessagesService }           from '../messages/messages.service';
import { MessengerEmailParamsModel } from '../messages/messenger/typings/messenger.email-params';
import { MessengerService }          from '../messages/messenger/messenger.service';
import { VehicleVisualModel }        from './typings/vehicle-visuals';

@Component({
  selector   : 'wor-vehicle-visuals-email',
  template: require('./vehicle-visuals.email.component.html')
})
export class VehicleVisualsEmailComponent implements OnInit {
  @Input() customer : CustomerModel;
  @Input() url      : string;
  @Input() visual   : VehicleVisualModel;

  email   : MessengerEmailParamsModel = {};
  sending = false;

  constructor (
    public  activeModal     : NgbActiveModal,
    private messagesService : MessagesService,
    private messengerService: MessengerService,
    private sanitizer       : DomSanitizer,
    private translateService: TranslateService
  ) {}

  // The vendor's text lands in the editor as HTML, so it is sanitised as legacy $translate did.
  ngOnInit () : void {
    const title = this.sanitize(this.visual.title || this.visual.en_AU);
    const url   = this.sanitizer.sanitize(SecurityContext.URL, this.url) || '';

    this.email = {
      email_address: this.customer?.email,
      body         : this.translateService.instant('JS_SPACE.VEHICLE_VISUALS.EMAIL_BODY', {
        desc: this.sanitize(this.visual.description || this.visual.description_en_AU),
        line: '<br>',
        link: `<a href="${ url }" target="_blank">here</a>`,
        title
      }),
      subject: this.translateService.instant('JS_SPACE.VEHICLE_VISUALS.EMAIL_SUBJECT', { title })
    };
  }

  send ( form : NgForm ) : void {
    if ( form.invalid ) {
      return;
    }

    this.sending = true;

    this.messengerService.sendEmail(this.email)
    .then(() => this.activeModal.close(true))
    .catch(error => this.messagesService.error(error))
    .finally(() => {
      this.sending = false;
    });
  }

  private sanitize ( value : string ) : string {
    return this.sanitizer.sanitize(SecurityContext.HTML, value) || '';
  }
}
